import Link from 'next/link'
import React from 'react'

export function LinkWrapper({
    children,
    href,
    disabled,
    passHref,
    onClick,
    ...props
}: {
    href?: string
    disabled?: boolean
    children?: React.ReactNode
    passHref?: boolean
    className?: string
    rel?: string
    target?: string
    onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
}) {
    if (!href || disabled)
        return (
            <button aria-label="link button" disabled={disabled} {...props}>
                {children}
            </button>
        )

    return (
        <Link href={href} passHref={passHref} onClick={onClick} {...props}>
            {children}
        </Link>
    )
}
